@use "~@optimizely/design-tokens/dist/scss/colors";

:host {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.custom-dropdown {
  position: relative;

  &__icon {
    height: var(--global-nav-icon-size);
    width: var(--global-nav-icon-size);
    color: #fff;
    background: transparent;
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }

    &:hover,
    &:focus-within {
      background-color: #b3c3ff;
      color: colors.$tile-hover-text-title-color
    }

    &:focus-within {
      background-color: #f0f3ff;
    }
  }

  &__menu {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    min-width: 200px;
    margin: 0;
    padding: 0;
    border: 1px solid #cecece;
    list-style: none;

    &--right {
      right: 24px; // right padding to align with icon
    }
  }

  &:focus-within>.custom-dropdown__menu {
    display: block;
    z-index: 999999;
  }
}
